import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({
    empresa: "", cnpj: "", nome: "", email: "", password: "",
  });
  const [busy, setBusy] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Empresa cadastrada com sucesso");
      nav("/");
    } catch (err) {
      const d = err?.response?.data?.detail || "Falha no cadastro";
      toast.error(typeof d === "string" ? d : "Erro ao cadastrar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6" data-testid="register-page">
      <Card className="w-full max-w-xl p-8 rounded-sm border border-zinc-200 shadow-none">
        <div className="mb-8 flex items-center gap-3">
          <img
              src="icone-logo-up2.png"
              alt="UP2 Soluções"
              className="h-20 w-20 object-contain"
            />
          <span className="font-display font-bold">UP2 FINANCE HUB</span>
        </div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2">Novo tenant</div>
        <h2 className="font-display text-3xl font-bold mb-1">Cadastrar empresa</h2>
        <p className="text-sm text-zinc-500 mb-8">Crie sua conta multi-tenant em segundos.</p>

        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-1.5 sm:col-span-2">
            <Label className="text-xs uppercase tracking-wider font-semibold">Empresa</Label>
            <Input required value={form.empresa} onChange={update("empresa")} className="rounded-sm h-11" data-testid="register-empresa-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider font-semibold">CNPJ</Label>
            <Input required value={form.cnpj} onChange={update("cnpj")} className="rounded-sm h-11 font-mono" data-testid="register-cnpj-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider font-semibold">Seu nome</Label>
            <Input required value={form.nome} onChange={update("nome")} className="rounded-sm h-11" data-testid="register-nome-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider font-semibold">E-mail</Label>
            <Input required type="email" value={form.email} onChange={update("email")} className="rounded-sm h-11" data-testid="register-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider font-semibold">Senha</Label>
            <Input required type="password" minLength={6} value={form.password} onChange={update("password")} className="rounded-sm h-11" data-testid="register-password-input" />
          </div>

          <div className="sm:col-span-2 mt-2 flex items-center gap-3">
            <Button type="submit" disabled={busy} className="rounded-sm h-11 px-6 font-semibold" data-testid="register-submit-button">
              {busy ? "Criando..." : "Criar conta"}
            </Button>
            <Link to="/login" className="text-sm text-zinc-500 hover:text-zinc-900" data-testid="link-login">
              Já tem conta? Entrar
            </Link>
          </div>
        </form>
      </Card>
    </div>
  );
}
